module.exports = __webpack_public_path__ + "static/media/football.b2a29576.svg";